import { useTranslation } from 'react-i18next'

import { FloatingTooltip } from '../../../../Floating'
import { TABLE_EMPTY_TEXT } from '../../../../Table'
import Text from '../../../../Text'
import {
  getMatchCoverageText,
  getMatchScorePercent,
} from '../../RentalPortalMatch.utils'
import { RentalPortalMatchScoreRing } from '../../RentalPortalMatchScoreRing'
import { getMatchFitCellScoreState } from '../RentalPortalMatchFitCell.utils'

import * as styles from '../RentalPortalMatchFitCell.module.css'

function RentalPortalMatchFitCellScore({ isScoreOnly, match, ringSize }) {
  const { t } = useTranslation()

  const { dashTooltipKey, hasCoverage, hasDash, hasRing } =
    getMatchFitCellScoreState({ isScoreOnly, match })

  return (
    <>
      {hasRing ? (
        <RentalPortalMatchScoreRing
          className={styles.ring}
          score={match.score}
          size={ringSize}
        />
      ) : null}
      <span className={styles.score}>
        {hasRing ? (
          <Text className={styles.numeral}>
            {`${getMatchScorePercent(match.score)} %`}
          </Text>
        ) : null}
        {hasCoverage ? (
          <Text isSecondary className={styles.coverage}>
            {getMatchCoverageText(match)}
          </Text>
        ) : null}
        {hasDash ? (
          <FloatingTooltip content={dashTooltipKey ? t(dashTooltipKey) : null}>
            <Text isSecondary>{TABLE_EMPTY_TEXT}</Text>
          </FloatingTooltip>
        ) : null}
      </span>
    </>
  )
}

export default RentalPortalMatchFitCellScore
